import cal from "../../assets/utils/images/Intagration image/cal.png";
import calendly from "../../assets/utils/images/Intagration image/calendly.png";
import gohighlevel from "../../assets/utils/images/Intagration image/gohighlevel.png";
import google_calendar from "../../assets/utils/images/Intagration image/google_calendar.svg";
import mail from "../../assets/utils/images/Intagration image/mail.png";
import make from "../../assets/utils/images/Intagration image/make.png";
import twilio from "../../assets/utils/images/Intagration image/twilio.svg";
import zapier_icon from "../../assets/utils/images/Intagration image/zapier-icon.svg";
import zoho from "../../assets/utils/images/Intagration image/zohocrm.png"; 
import hubspot from "../../assets/utils/images/Intagration image/hubspot.svg";
import salesforce from "../../assets/utils/images/Intagration image/salesforce.png";
import pipedrive from "../../assets/utils/images/Intagration image/pipedrive.png";
import bigin from "../../assets/utils/images/Intagration image/bigin.png";
import n8n from "../../assets/utils/images/Intagration image/n8n.png";
import { PROTNUMBER_LISTS, PROTOCOL_LISTS } from "../Dashboard/Constant";
// import meet from "../../assets/utils/images/Intagration image/meet.svg";
// import sms from "../../assets/utils/images/Intagration image/sms.png";
// import stripe_icon from "../../assets/utils/images/Intagration image/stripe-icon.svg";
// import zoom from "../../assets/utils/images/Intagration image/zoom.svg";

export const cardData = [
    { img: google_calendar, name: 'gcalendar' , heading: 'Google Calendar', subheading: 'Calendar',discription : 'Handle all your scheduling needs, and keep your calendar organized.', component:{ button : {details : 'More Info', install : '', key: 'google-calendar'}} },
    { img: gohighlevel, name: 'ghl_calendar' ,heading: 'HighLevel', subheading: 'Calendar', discription : 'Take control of your calendar and simplify scheduling.',component:{ button : {details : 'More Info', install : '', key: 'highlevel'}}},
    { img: cal, name: 'cal.com' , heading: 'Cal.com', subheading: 'Calendar', discription : 'Manage your schedule effortlessly and stay organized.', component:{ button : {details : 'More Info', install : '', key: 'cal.com'}} },
    // { img: twilio, name: 'twilio' , heading: 'Twilio for Calls', subheading: 'Voice', discription : 'Import your own phone numbers to make calls', component:{ button : {details : 'More Info', install : '', key: 'twilio'}} },
    { img: twilio, name: 'twilio' , heading: 'Twilio for SMS', subheading: 'Communication', discription : 'Automatically send an SMS to the caller post-call.', component:{ button : {details : 'More Info', install : '', key: 'twilio'}} },
    { img: mail, name: 'email' , heading: 'Email SMTP', subheading: 'Communication',discription : 'Send emails directly from the app.', component:{ button : {details : 'More Info', install : '', key: 'email'}} },
    { img: make, name: 'make' , heading: 'Make', subheading: 'Automation',discription : 'Trigger calls and in/after call actions.', component:{ button : {details : 'More Info', install : '', key: 'make'}} },
    { img: zapier_icon, name: 'zapier' , heading: 'Zapier', subheading: 'Automation',discription : 'Automate post-call actions and workflows.', component:{ button : {details : 'More Info', install : '', key: 'zapier'}} }, //Productivity
    { img: n8n, name: 'n8n' , heading: 'N8N', subheading: 'Automation',discription : 'Connect workflows and trigger actions.', component:{ button : {details : 'More Info', install : '', key: 'stripe'}} },
    { img: zoho, name: 'zoho' , heading: 'Zoho CRM', subheading: 'CRM',discription : 'Qualify leads, schedule appointments, and sync call data to ZOHO CRM.', /*component:{ button : {details : 'More Info', install : '', key: 'zoho'}}*/ },
    { img: hubspot, name: 'hubspot' , heading: 'HubSpot CRM', subheading: 'CRM',discription : 'Qualify leads, schedule appointments, and sync call data to HubSpot CRM.', /*component:{ button : {details : 'More Info', install : '', key: 'hubspot'}} */},
    { img: bigin, name: 'bigin' , heading: 'Bigin CRM', subheading: 'CRM',discription : 'Qualify leads, schedule appointments, and sync call data to Bigin CRM.', /* component:{ button : {details : 'More Info', install : '', key: 'bigin'}} */},
    { img: salesforce, name: 'salesforce' , heading: 'Salesforce CRM', subheading: 'CRM',discription : 'Qualify leads, schedule appointments, and sync call data to Salesforce CRM.', /* component:{ button : {details : 'More Info', install : '', key: 'email'}} */ },
    { img: pipedrive, name: 'pipedrive' , heading: 'Pipe Drive CRM', subheading: 'CRM',discription : 'Qualify leads, schedule appointments, and sync call data to Pipe Drive CRM', /* component:{ button : {details : 'details', install : 'install', key: 'calendly'}} */ },
    { img: calendly, name: 'calendly' , heading: 'Calendly', subheading: 'Calendar',discription : 'Easily plan, schedule, and organize your calendar.', /* component:{ button : {details : 'details', install : 'install', key: 'stripe'}} */ },
];
export const modalOptions = {
    "cal.com" : { 
        label: "Cal.com", 
        fields: [{ name: "apiKey", label: "API Key", type: "text" }], 
        desc: ['Ensure that the API key is set to "Never Expires".'] 
    },
    "twilio" : { 
        label: "Twilio", 
        fields: [
            { name: "apiKey", label: "SID", type: "text" },
            { name: "phoneno", label: "Phone Number", type: "text" },
            { name: "authToken", label: "Auth Token", type: "text" },
        ]
    },
    "email" : { 
        label: "Email", 
        fields: [
            { name: "name", label: "User Name", type: "text" },
            { name: "password", label: "Password", type: "password" },
            { name: "url", label: "Host", type: "text" },
            { 
                name: "protocol", 
                label: "Protocol", 
                type: "dropdown", 
                options: PROTOCOL_LISTS
            },
            { 
                name: "port", 
                label: "Port Number", 
                type: "dropdown" ,
                options: PROTNUMBER_LISTS
            },
            { name: "sender", label: "Sender Name", type: "text" },
            { name: "fromaddress", label: "From Address", type: "text" }
        ]
    },
    "highlevel" : { 
        label: "Go Highlevel", 
        fields: [{ name: "apiKey", label: "API Key", type: "text" }], 
        desc: ['Ensure that the API key is set to "Never Expires".'] 
    }
}

/* export const modalOption = {
   "cal.com" : { 
       
      label: "API Key", 
      fields: [{ name: "apiKey", label: "API Key", type: "text" }], 
      desc: ['Ensure that the API key is set to "Never Expires".'] 
    },
 "twilio" : { 
      label: "Twilio Credentials", 
      fields: [
        { name: "apiKey", label: "SID", type: "text" },
        { name: "authToken", label: "Auth Token", type: "text" }
      ]
    },
  "email" : { 
      label: "Email Settings", 
      fields: [
        { name: "name", label: "User Name", type: "text" },
        { name: "password", label: "Password", type: "password" },
        { name: "url", label: "Url", type: "text" },
        { name: "port", label: "Port Number", type: "text" },
        { 
          name: "protocol", 
          label: "Protocol", 
          type: "dropdown", 
          options: [
            { label: "SSL", value: "ssl" },
            { label: "TLS", value: "tls" }
          ]
        },
        { name: "sender", label: "Sender Name", type: "text" },
        { name: "fromaddress", label: "From Address", type: "text" }
      ]
    },
}; */


/* export const details = [ {
    'cal.com' : {
        headerComponent : { 
            name:"Cal.com",
            image:{
                    "classname" : "cloud-teley-image",
                    "icon" : cal
                },
            subheading: 'Calendar',
            btn : '+ Install',
        },
        website : {
            name : 'Website',
            link : 'https://cal.com'
        },
        overview : {
            name : 'Overview',
            details : 'The Voicemetrics integration with Cal.com transforms scheduling into an effortless experience for your team and customers. By combining OneInbox’s advanced AI calling capabilities with Cal.com’s flexible calendar management, businesses can fully automate appointment booking, rescheduling, and reminders. This integration lets you simplify workflows and increase efficiency by enabling AI agents to handle scheduling tasks seamlessly, even in high-volume scenarios.'
        },
        keybenefits : {
            name : 'Key Benefits',
            benefitsSubheadind : ['Automated Scheduling and Rescheduling','Enhanced Customer Experience','Real-Time Syncing'],
            benefitsDetails : ['Free up valuable time by allowing our AI-powered agents to take over appointment bookings and rescheduling tasks. OneInbox integrates with Cal.com to check real-time availability and instantly confirm bookings on your behalf.','Provide a smoother, faster experience by offering 24/7 booking capabilities. OneInbox AI agents can assist customers anytime, checking availability and scheduling appointments within seconds.','All appointments are automatically synced with your Cal.com calendar, ensuring you and your team have the latest information without needing manual updates.'],
        },
        //key : 'cal.com'
    },
    'Googlecalender' : {
        headerComponent : { 
            name:"Google Calender",
            image:{
                    "classname" : "google_calendar",
                    "icon" : google_calendar
                },
            subheading: 'Calendar',
            btn : '+ Install',
        },
        website : {
            name : 'Website',
            link : 'https://calendar.google.com'
        },
        overview : {
            name : 'Overview',
            details : 'The Voicemetrics integration with Google Calendar simplifies scheduling for individuals and businesses by connecting advanced AI calling capabilities to Google’s reliable calendar platform. With this integration, users can automate appointment bookings, check real-time slot availability, and manage their schedules effortlessly.'
        },
        keybenefits : {
            name : 'Key Benefits',
            benefitsSubheadind : ['AI-Powered Scheduling','Improved Accessibility','Seamless Synchronization'],
            benefitsDetails : ['Enable AI agents to book and reschedule appointments by checking your Google Calendar availability, reducing manual effort.','Offer round-the-clock booking and scheduling support, ensuring customers can book appointments at any time.','Automatically sync appointments with Google Calendar to keep your schedule up-to-date and eliminate double bookings.'],
        },
       // key : 'Google'
    },
    'gohighlevel' : {
        headerComponent : { 
            name:"HighLevel",
            image:{
                    "classname" : "gohighlevel",
                    "icon" : gohighlevel
                },
            subheading: 'Calendar',
            btn : '+ Install',
        },
        website : {
            name : 'Website',
            link : 'www.gohighlevel.com'
        },
        overview : {
            name : 'Overview',
            details : 'The Voicemetrics integration with HighLevel empowers agencies to streamline client interactions and calendar management. By connecting OneInbox’s advanced AI calling capabilities with HighLevel’s robust CRM and calendar tools, businesses can automate scheduling, client follow-ups, and appointment reminders. This integration simplifies workflows and enhances team productivity, even in high-demand scenarios.'
        },
        keybenefits : {
            name : 'Key Benefits',
            benefitsSubheadind : ['Automated Appointment Management','Streamlined Client Interactions','Integrated Workflows'],
            benefitsDetails : ['Allow AI-powered agents to schedule and reschedule appointments directly within HighLevel, leveraging real-time calendar availability for seamless booking.','Enhance customer satisfaction with 24/7 AI support, ensuring clients can book and update appointments whenever needed.','Sync appointments across HighLevel calendars, ensuring your agency operates with up-to-date information without manual effort.'],
        },
        key : 'gohighlevel'
    },
    'twilio' : {
        headerComponent : { 
            name:"Twilio",
            image:{
                    "classname" : "gohighlevel",
                    "icon" : twilio
                },
            subheading: 'Voice & video',
            btn : '+ Install',
        },
        website : {
            name : 'Website',
            link : 'www.gohighlevel.com'
        },
        overview : {
            name : 'Overview',
            details : 'The Voicemetrics integration with HighLevel empowers agencies to streamline client interactions and calendar management. By connecting OneInbox’s advanced AI calling capabilities with HighLevel’s robust CRM and calendar tools, businesses can automate scheduling, client follow-ups, and appointment reminders. This integration simplifies workflows and enhances team productivity, even in high-demand scenarios.'
        },
        keybenefits : {
            name : 'Key Benefits',
            benefitsSubheadind : ['Automated Appointment Management','Streamlined Client Interactions','Integrated Workflows'],
            benefitsDetails : ['Allow AI-powered agents to schedule and reschedule appointments directly within HighLevel, leveraging real-time calendar availability for seamless booking.','Enhance customer satisfaction with 24/7 AI support, ensuring clients can book and update appointments whenever needed.','Sync appointments across HighLevel calendars, ensuring your agency operates with up-to-date information without manual effort.'],
        },
        //key : 'twilio'
    },
    'Email' : {
        headerComponent : { 
            name:"Email",
            image:{
                    "classname" : "mail",
                    "icon" : mail
                },
            subheading: 'Communication',
            btn : '+ Install',
        },
        website : {
            name : 'Website',
            link : 'https://www.gmail.com'
        },
        overview : {
            name : 'Overview',
            details : 'The Voicemetrics integration with HighLevel empowers agencies to streamline client interactions and calendar management. By connecting OneInbox’s advanced AI calling capabilities with HighLevel’s robust CRM and calendar tools, businesses can automate scheduling, client follow-ups, and appointment reminders. This integration simplifies workflows and enhances team productivity, even in high-demand scenarios.'
        },
        keybenefits : {
            name : 'Key Benefits',
            benefitsSubheadind : ['Automated Appointment Management','Streamlined Client Interactions','Integrated Workflows'],
            benefitsDetails : ['Allow AI-powered agents to schedule and reschedule appointments directly within HighLevel, leveraging real-time calendar availability for seamless booking.','Enhance customer satisfaction with 24/7 AI support, ensuring clients can book and update appointments whenever needed.','Sync appointments across HighLevel calendars, ensuring your agency operates with up-to-date information without manual effort.'],
        },
        //key : 'twilio'
    }
}]; */ 


